import { render, staticRenderFns } from "./UsuariosNewOrEdit.vue?vue&type=template&id=3a4f83ec&"
import script from "./UsuariosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./UsuariosNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports